import useShimmer from "hooks/useShrimmer";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cmsContentDetailApi } from "services/cms-content";
import CmsContentShrimmer from "shrimmer/CmsContent/CmsContentShrimmer";
import SuperTag from "utils/SuperTag";

const AboutUs = () => {
  const [contentValue, setContentValue] = useState("");
  // hook
  const [showShimmer, setShowShimmer] = useShimmer(CmsContentShrimmer);
  const { t } = useTranslation();

  // Content Detail
  const getContentDetail = async (contentType) => {
    try {
      setShowShimmer(true);

      const responseData = await cmsContentDetailApi({
        type: contentType,
        userRole: "researcher",
      });

      const {
        data: { cms = {} },
        status,
      } = responseData;
      if (status === 200) {
        setContentValue(cms);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    getContentDetail("about");
  }, []);

  return (
    <>
      <div className="cmsPages">
        <div className="container">
          {showShimmer || (
            <div className="cms_content">
              <div className="page_title">
                {/* <h3>{t("HOME-FOOTER.About Us")}</h3> */}
                <h3>About us</h3>
              </div>
              <SuperTag>{contentValue?.description}</SuperTag>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AboutUs;
